import { render, staticRenderFns } from "./Hazard_Rating.vue?vue&type=template&id=3627a3a8&scoped=true&"
import script from "./Hazard_Rating.vue?vue&type=script&lang=js&"
export * from "./Hazard_Rating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3627a3a8",
  null
  
)

export default component.exports